/**
 * Used for representing the expanded/collapsed state of a dropdown
 * @type {React.ReactSVGElement}
 */
export const CHEVRON_DOWN = (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<g clipPath="url(#clip0_2861_5459)">
			<path
				d="M12 13.1717L16.95 8.22168L18.364 9.63568L12 15.9997L5.63599 9.63568L7.04999 8.22168L12 13.1717Z"
				fill="#101820"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2861_5459">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

/**
 * Used in copy link button in share design modal
 * @type {React.ReactSVGElement}
 */
export const COPY_LINK_CHAIN = (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path
			d="M10.8838 6.75902L12.0623 7.93753C14.3403 10.2156 14.3403 13.9091 12.0623 16.1871L11.7676 16.4817C9.48959 18.7598 5.7961 18.7598 3.51804 16.4817C1.23998 14.2037 1.23998 10.5102 3.51804 8.23216L4.69655 9.41066C3.06936 11.0378 3.06936 13.6761 4.69655 15.3032C6.32373 16.9304 8.96192 16.9304 10.5891 15.3032L10.8838 15.0086C12.5109 13.3814 12.5109 10.7432 10.8838 9.11608L9.70525 7.93753L10.8838 6.75902ZM16.4817 11.7677L15.3032 10.5892C16.9303 8.962 16.9303 6.32381 15.3032 4.69662C13.676 3.06944 11.0378 3.06944 9.41059 4.69662L9.116 4.99126C7.48878 6.61844 7.48878 9.25666 9.116 10.8838L10.2945 12.0623L9.116 13.2408L7.93745 12.0623C5.6594 9.78425 5.6594 6.0908 7.93745 3.81274L8.23208 3.51811C10.5102 1.24006 14.2036 1.24006 16.4817 3.51811C18.7598 5.79617 18.7598 9.48966 16.4817 11.7677Z"
			fill="currentColor"
		/>
	</svg>
);

/**
 * Used to denote a downloadable file (simulation file)
 * @type {React.ReactSVGElement}
 */
export const DOWNLOAD_FILE = (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
		<path d="M5.54545 1L6.45455 1V8.27273H5.54545V1Z" fill="#5E6773" />
		<path
			d="M3.46094 6.83108L4.10376 6.18825L6.67506 8.75955L6.03224 9.40237L3.46094 6.83108Z"
			fill="#5E6773"
		/>
		<path
			d="M7.96112 6.18821L8.60394 6.83104L6.03224 9.40237L5.38982 8.75951L7.96112 6.18821Z"
			fill="#5E6773"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.0909 8.27273V10.0909H1.90909L1.90909 8.27273H1V10.0909C1 10.593 1.40701 11 1.90909 11H10.0909C10.593 11 11 10.593 11 10.0909V8.27273H10.0909Z"
			fill="#5E6773"
		/>
	</svg>
);

/**
 * Used to denote a pdf product selection guide (additional resource)
 * @type {React.ReactSVGElement}
 */
export const PDF_DOCUMENT = (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<g clipPath="url(#clip0_2861_5576)">
			<path
				d="M6 0L14.1984 0C14.64 0 15 0.364 15 0.7936V15.2064C14.9998 15.4169 14.916 15.6188 14.767 15.7676C14.6181 15.9164 14.4162 16 14.2056 16L1.79442 16.012C1.68936 16.0113 1.58548 15.9898 1.4887 15.949C1.39192 15.9081 1.30414 15.8485 1.23037 15.7737C1.1566 15.6989 1.09829 15.6103 1.05877 15.513C1.01924 15.4156 0.999282 15.3115 1.00002 15.2064L1 5L6 0ZM4 5H6V3L4 5ZM8 2L7.99609 6.2C7.99609 6.41217 7.91181 6.61566 7.76178 6.76569C7.61175 6.91571 7.40827 7 7.19609 7H3V14H13V2H8Z"
				fill="#8E3DC7"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2861_5576">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

/**
 * Used for links to external pages
 * @type {React.ReactSVGElement}
 */
export const OPEN_IN_NEW_TAB = (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
		<g clipPath="url(#clip0_1679_202)">
			<path
				d="M8.33333 3.26611V4.93278H4.16667V16.5994H15.8333V12.4328H17.5V17.4328C17.5 17.6538 17.4122 17.8658 17.2559 18.022C17.0996 18.1783 16.8877 18.2661 16.6667 18.2661H3.33333C3.11232 18.2661 2.90036 18.1783 2.74408 18.022C2.5878 17.8658 2.5 17.6538 2.5 17.4328V4.09945C2.5 3.87843 2.5878 3.66647 2.74408 3.51019C2.90036 3.35391 3.11232 3.26611 3.33333 3.26611H8.33333ZM14.7558 7.18861L10 11.9444L8.82167 10.7661L13.5775 6.01028L10.8333 3.26611H17.5V9.93278L14.7558 7.18861Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1679_202">
				<rect width="20" height="20" fill="white" transform="translate(0 0.766113)" />
			</clipPath>
		</defs>
	</svg>
);

/**
 * Used to denote a file that can be opened in a new tab (product selection guide)
 * @type {React.ReactSVGElement}
 */
export const OPEN_IN_NEW_TAB_SMALL = (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.9987 4.63695H10.0896V2.59845L6.23312 6.45512L5.59203 5.81037L9.49309 1.90919L7.36196 1.90919V1L10.9987 1.0002V4.63695ZM1.90919 3.72777H5.54688V2.81858H1.90919C1.40706 2.81858 1 3.22564 1 3.72777V10.0921C1 10.5942 1.40706 11.0013 1.90919 11.0013H8.27349C8.77562 11.0013 9.18268 10.5942 9.18268 10.0921V6.45533H8.27349V10.0921H1.90919L1.90919 3.72777Z"
			fill="#5E6773"
		/>
	</svg>
);

/**
 * Used in filter dropdown option
 * @type {object}
 */
export const SELECTED_OPTION = (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<g clipPath="url(#clip0_2861_28671)">
			<path
				d="M9.99999 15.1715L19.192 5.97852L20.607 7.39252L9.99999 17.9995L3.63599 11.6355L5.04999 10.2215L9.99999 15.1715Z"
				fill="#0067B9"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2861_28671">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

/**
 * Used in share design modal
 * @type {object}
 */
export const SHARE_NODES = (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			d="M13.1202 17.0228L8.92129 14.7324C8.19135 15.5125 7.15261 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C7.15255 8 8.19125 8.48746 8.92118 9.26746L13.1202 6.97713C13.0417 6.66441 13 6.33707 13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6C21 8.20914 19.2091 10 17 10C15.8474 10 14.8087 9.51251 14.0787 8.73246L9.87977 11.0228C9.9583 11.3355 10 11.6629 10 12C10 12.3371 9.95831 12.6644 9.87981 12.9771L14.0788 15.2675C14.8087 14.4875 15.8474 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.6629 13.0417 17.3355 13.1202 17.0228ZM6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14ZM17 8C18.1046 8 19 7.10457 19 6C19 4.89543 18.1046 4 17 4C15.8954 4 15 4.89543 15 6C15 7.10457 15.8954 8 17 8ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z"
			fill="#212836"
		/>
	</svg>
);

/**
 * Used for app share design button
 * @type {React.ReactSVGElement}
 */
export const SHARE_ARROW = (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
		<path
			d="M9.79166 13.2662H8.12499C5.48507 13.2662 3.16371 14.6301 1.82718 16.6918C1.72025 16.8567 1.45833 16.7961 1.45833 16.5995C1.45833 11.9972 5.18929 8.2662 9.79166 8.2662V5.77898C9.79166 4.93778 10.767 4.47246 11.4209 5.00174L17.5815 9.98895C18.0759 10.3892 18.0759 11.1432 17.5815 11.5434L11.4209 16.5307C10.767 17.0599 9.79166 16.5946 9.79166 15.7534V13.2662ZM8.12499 11.5995H11.4583V14.356L15.8928 10.7662L11.4583 7.1764V9.93286H9.79166C7.77458 9.93286 4.79166 11.1829 3.54166 13.2662C4.79166 12.2421 6.942 11.5995 8.12499 11.5995Z"
			fill="currentColor"
		/>
	</svg>
);

/**
 * Used for denoting an LTSpice simulation file (additional resource)
 * @type {React.ReactSVGElement}
 */
export const SPANNER_TOOL = (
	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
		<mask id="path-1-inside-1_2861_5551" fill="white">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.78864 1.50789C10.0508 2.77008 10.5206 4.52458 10.198 6.15327L15.7666 11.7218C16.1571 12.1124 16.1571 12.7455 15.7666 13.136L13.136 15.7667C12.7454 16.1572 12.1123 16.1572 11.7217 15.7667L6.15311 10.1981C4.52447 10.5206 2.77004 10.0508 1.50789 8.78864C-0.267885 7.01286 -0.475222 4.26258 0.88588 2.25924L3.34987 4.72323C3.74039 5.11375 4.3768 5.11051 4.76732 4.71999C5.15784 4.32946 5.16109 3.69306 4.77056 3.30253L2.31594 0.847909C4.3142 -0.471185 7.02955 -0.251191 8.78864 1.50789Z"
			/>
		</mask>
		<path
			d="M10.198 6.15327L8.23614 5.76468L8.02864 6.81231L8.78382 7.56748L10.198 6.15327ZM8.78864 1.50789L10.2028 0.0936783V0.0936779L8.78864 1.50789ZM15.7666 11.7218L17.1808 10.3076L15.7666 11.7218ZM15.7666 13.136L14.3524 11.7218L14.3524 11.7218L15.7666 13.136ZM11.7217 15.7667L13.136 14.3525L13.136 14.3525L11.7217 15.7667ZM6.15311 10.1981L7.56733 8.78385L6.81218 8.0287L5.76459 8.23616L6.15311 10.1981ZM1.50789 8.78864L0.0936779 10.2028L0.0936781 10.2028L1.50789 8.78864ZM0.88588 2.25924L2.30009 0.845028L0.590384 -0.864681L-0.768422 1.13528L0.88588 2.25924ZM3.34987 4.72323L4.76408 3.30901L4.76408 3.30901L3.34987 4.72323ZM4.76732 4.71999L6.18153 6.1342L6.18153 6.1342L4.76732 4.71999ZM4.77056 3.30253L3.35635 4.71675L4.77056 3.30253ZM2.31594 0.847909L1.21411 -0.821219L-0.831361 0.529038L0.901724 2.26212L2.31594 0.847909ZM12.1599 6.54185C12.6066 4.2864 11.9567 1.84754 10.2028 0.0936783L7.37442 2.9221C8.14492 3.69261 8.43459 4.76276 8.23614 5.76468L12.1599 6.54185ZM17.1808 10.3076L11.6122 4.73905L8.78382 7.56748L14.3524 13.136L17.1808 10.3076ZM17.1808 14.5503C18.3524 13.3787 18.3524 11.4792 17.1808 10.3076L14.3524 13.136C13.9619 12.7455 13.9619 12.1124 14.3524 11.7218L17.1808 14.5503ZM14.5502 17.1809L17.1808 14.5503L14.3524 11.7218L11.7217 14.3525L14.5502 17.1809ZM10.3075 17.1809C11.4791 18.3525 13.3786 18.3525 14.5502 17.1809L11.7217 14.3525C12.1123 13.962 12.7454 13.962 13.136 14.3525L10.3075 17.1809ZM4.7389 11.6123L10.3075 17.1809L13.136 14.3525L7.56733 8.78385L4.7389 11.6123ZM0.0936781 10.2028C1.84749 11.9567 4.28625 12.6066 6.54164 12.16L5.76459 8.23616C4.7627 8.43457 3.69258 8.1449 2.9221 7.37442L0.0936781 10.2028ZM-0.768422 1.13528C-2.65891 3.9178 -2.37352 7.73565 0.0936779 10.2028L2.92211 7.37442C1.83775 6.29007 1.70847 4.60736 2.54018 3.3832L-0.768422 1.13528ZM4.76408 3.30901L2.30009 0.845028L-0.528334 3.67346L1.93565 6.13744L4.76408 3.30901ZM3.35311 3.30577C3.7352 2.92368 4.36515 2.91009 4.76408 3.30901L1.93565 6.13744C3.11563 7.31742 5.01839 7.29734 6.18153 6.1342L3.35311 3.30577ZM3.35635 4.71675C2.95742 4.31782 2.97101 3.68787 3.35311 3.30577L6.18153 6.1342C7.34468 4.97106 7.36475 3.06829 6.18477 1.88832L3.35635 4.71675ZM0.901724 2.26212L3.35635 4.71675L6.18477 1.88832L3.73015 -0.566305L0.901724 2.26212ZM10.2028 0.0936779C7.75874 -2.35043 3.98935 -2.65321 1.21411 -0.821219L3.41776 2.51704C4.63906 1.71084 6.30036 1.84805 7.37442 2.92211L10.2028 0.0936779Z"
			fill="#8E3DC7"
			mask="url(#path-1-inside-1_2861_5551)"
		/>
	</svg>
);
